import { render } from "./PublicationPreview.vue.js?vue&type=template&id=08479605!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationPreview.vue?vue&type=template&id=08479605"
import script from "./PublicationPreview.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationPreview.vue?vue&type=script&lang=js"
export * from "./PublicationPreview.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08479605"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08479605', __exports__)) {
    api.reload('08479605', __exports__)
  }
  
  module.hot.accept("./PublicationPreview.vue.js?vue&type=template&id=08479605!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationPreview.vue?vue&type=template&id=08479605", () => {
    api.rerender('08479605', render)
  })

}


export default __exports__